import React, { useRef, useState } from "react";
import { Button, Popover, PopoverOrigin } from "@material-ui/core";

interface OverflowMenuButtonProps extends React.ComponentProps<typeof Button> {
  buttonContents: React.ReactNode;
}

const origin = (vertical: "bottom" | "top" = "bottom"): PopoverOrigin => ({ vertical, horizontal: "center" });
const originProps = { anchorOrigin: origin(), transformOrigin: origin("top") };

const OverflowMenuButton = ({ buttonContents, children, ...props }: OverflowMenuButtonProps) => {
  const anchorEl = useRef<HTMLButtonElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const close = () => setIsOpen(false);

  return (
    <>
      <Button {...props} ref={anchorEl} onClick={() => setIsOpen(true)}>
        {buttonContents}
      </Button>
      <Popover anchorEl={anchorEl.current} open={isOpen} onClick={close} onClose={close} {...originProps}>
        {children}
      </Popover>
    </>
  );
};

export default OverflowMenuButton;
